export const API_BASE_URL =  import.meta.env.VITE_BASE_URL || '__VITE_BASE_URL__'
export const API_BASE_URL_LOGIN =  import.meta.env.VITE_BASE_URL_LOGIN || '__VITE_BASE_URL_LOGIN__'
export const MAPS_API_KEY = import.meta.env.VITE_MAPS_API_KEY || '__VITE_MAPS_API_KEY__'